var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './Button.module.scss';
var Button = function (_a) {
    var children = _a.children, title = _a.title, primary = _a.primary, danger = _a.danger, warning = _a.warning, teritary = _a.teritary, small = _a.small, fluid = _a.fluid, disabled = _a.disabled, className = _a.className, id = _a.id, dataId = _a.dataId, onClick = _a.onClick, type = _a.type;
    var classes = "".concat(primary ? styles.Primary : '', " ").concat(danger ? styles.Danger : '', " ").concat(warning ? styles.Warning : '', " ").concat(teritary ? styles.Teritary : '', " ").concat(small ? styles.Small : '', " ").concat(fluid ? styles.Fluid : '');
    return (_jsx("button", __assign({ type: type, id: id, className: "".concat(styles.Button, " ").concat(classes, " ").concat(className ? className : ''), disabled: disabled, "data-testid": dataId, onClick: onClick }, { children: children || title })));
};
Button.propTypes = {
    title: PropTypes.string,
    primary: PropTypes.bool,
    danger: PropTypes.bool,
    warning: PropTypes.bool,
    teritary: PropTypes.bool,
    small: PropTypes.bool,
    fluid: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onClick: PropTypes.func,
};
Button.defaultProps = {
    className: '',
    type: 'button',
};
export { Button };
//# sourceMappingURL=Button.js.map